import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

export default function HotScroll() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const exclusiveArticles = articles.filter((a) => a.exclusive).slice(0, 6);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  };

  const scroll = (direction: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const scrollAmount = 320;
    el.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
    setTimeout(checkScroll, 350);
  };

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              独家爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              第一手独家内幕，全网首发曝光
            </p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-300 text-foreground-600 hover:text-foreground-900 hover:border-foreground-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-300 text-foreground-600 hover:text-foreground-900 hover:border-foreground-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          onScroll={checkScroll}
          className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {exclusiveArticles.map((article) => {
            const category = categories.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.id}
                to="/category/all"
                className="group flex-shrink-0 w-[280px] md:w-[320px] bg-background-50 rounded-lg overflow-hidden snap-start transition-colors hover:bg-background-100 cursor-pointer"
              >
                <span className="absolute top-3 left-3 z-10 px-2 py-0.5 text-xs font-medium bg-accent-500 text-white rounded whitespace-nowrap">
                  独家
                </span>
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views >= 10000 ? `${(article.views / 10000).toFixed(0)}万阅读` : `${article.views}阅读`}
                    </span>
                    {category && (
                      <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded whitespace-nowrap">
                        {category.name}
                      </span>
                    )}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}